export const Layout = ({children}) => (
  <div className="bg-gray-100 min-h-screen">
    <div className="max-w-lg mx-auto bg-white p-3">
      {children}
    </div>
  </div>
)